import React, { useEffect, useState } from "react";
import Avatar from "react-avatar";
import Post from "../Post/Post";
import Button from "../Shared/Button/Button";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { toast } from "react-toastify";
import { updateUser } from "../../features/auth/authSlice";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const OthersProfileSection = ({ user, posts, onPostLike }) => {
  const dispatch = useDispatch();
  //get the user as logged in user from the redux store
  const { user: loggedInUser, token } = useSelector((state) => state.auth);
  const [alreadyFriend, setAlreadyFriend] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selfProfile, setSelfProfile] = useState(false);

  const addFriendHandler = async () => {
    //check if the user is already a friend
    if (loggedInUser.friends.includes(user._id)) {
      return toast.error("User is already a friend");
    }
    // make a request to get the posts of the user
    const response = await axios
      .put(
        `${BACKEND_URL}/users/friends/add/${user._id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .catch((err) => {
        toast.error(err.response.data.message);
        setIsLoading(false);
      });

    // if response is received from the server update the user in the redux store
    if (response) {
      dispatch(updateUser(response.data.user));
      setIsLoading(false);
      toast.success("User added as a friend");
    }
  };

  const removeFriendHandler = async () => {
    //check if the user is already a friend
    if (!loggedInUser.friends.includes(user._id)) {
      return toast.error("User is not a friend");
    }
    // make a request to get the posts of the user
    const response = await axios
      .put(
        `${BACKEND_URL}/users/friends/remove/${user._id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .catch((err) => {
        toast.error(err.response.data.message);
        setIsLoading(false);
      });

    // if response is received from the server update the user in the redux store
    if (response) {
      dispatch(updateUser(response.data.user));
      setIsLoading(false);
      toast.success("User removed as a friend");
    }
  };

  useEffect(() => {
    //if logged in user or user is null, return
    if (!loggedInUser || !user) {
      return;
    }
    //check if the user is already a friend
    if (loggedInUser.friends.includes(user._id)) {
      setAlreadyFriend(true);
    } else {
      setAlreadyFriend(false);
    }
    if (loggedInUser._id === user._id) {
      setSelfProfile(true);
    } else {
      setSelfProfile(false);
    }
  }, [loggedInUser, user]);

  return (
    <>
      {/* // if the user is not null, render the profile section */}
      {user && (
        <div>
          <h1 className="text-3xl font-[600]">Profile</h1>
          <div className="flex justify-between items-center gap-4">
            <div className="my-6 flex gap-3 items-center">
              <div>
                <Avatar
                  name={`${user?.firstName} ${user?.lastName}`}
                  size="80"
                  round={10}
                />
              </div>
              <div>
                <h1 className="text-2xl">
                  {user?.firstName} {user?.lastName}
                </h1>
                <p className="font-[600]">@{user?.userName}</p>
              </div>
            </div>
            {!alreadyFriend && !selfProfile && (
              <Button
                className="text-white w-40"
                onClick={addFriendHandler}
                disabled={isLoading}
              >
                Add Friend
              </Button>
            )}
            {alreadyFriend && !selfProfile && (
              <Button
                className="text-white w-40"
                onClick={removeFriendHandler}
                disabled={isLoading}
              >
                Un Friend
              </Button>
            )}
          </div>
          <div className="my-3">
            <h1 className="text-2xl font-[600] my-4 underline">About</h1>
            <div className="grid grid-cols-3 gap-4 w-full mt-6">
              <div className="text-lg flex items-center gap-2">
                <h3 className="font-[600]">First Name:</h3>
                <p>{user?.firstName}</p>
              </div>
              <div className="text-lg flex items-center gap-2">
                <h3 className="font-[600]">Last Name:</h3>
                <p>{user?.lastName}</p>
              </div>
              <div className="text-lg flex items-center gap-2">
                <h3 className="font-[600]">User Name:</h3>
                <p className="break-all">{user?.userName}</p>
              </div>
              <div className="text-lg flex items-center gap-2">
                <h3 className="font-[600]">Email:</h3>
                <p className="break-all">{user?.email}</p>
              </div>
              <div className="text-lg flex items-center gap-2">
                <h3 className="font-[600]">Age:</h3>
                <p>{user?.age}</p>
              </div>
              <div className="text-lg flex gap-2">
                <h3 className="font-[600]">Address:</h3>
                <p>{user?.address === "" ? "Not Specified" : user?.address}</p>
              </div>
              <div className="text-lg flex items-center gap-2">
                <h3 className="font-[600]">Course:</h3>
                <p>{user?.course === "" ? "Not Specified" : user?.course}</p>
              </div>
              <div className="text-lg flex items-center gap-2">
                <h3 className="font-[600]">LinkedIn:</h3>
                <p>{user?.linkedIn === "" ? "N/A" : user?.linkedIn}</p>
              </div>
            </div>
          </div>
          <div className="py-2">
            <h1 className="text-2xl font-[600] my-4 underline">Hobbies</h1>
            <div>
              {/* // if the user has no hobbies, render the message */}
              {user?.hobbies.length === 0 ? (
                <p className="text-lg">No hobbies added</p>
              ) : (
                // else render the hobbies in a grid
                <div className="grid grid-cols-4 gap-4 w-full mt-6">
                  {user.hobbies.map((hobby, index) => (
                    <div className="text-lg flex items-center gap-2 bg-gray-100 py-2 px-4">
                      <h3 className="font-[600]">
                        {index + 1}
                        {")"}. {hobby}
                      </h3>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
          {posts && (
            <div className="py-2">
              <h1 className="text-2xl font-[600] my-4 underline">
                Recent Posts
              </h1>
              <div>
                {posts.length === 0 ? (
                  <p className="text-lg">No posts added</p>
                ) : (
                  <div className="flex flex-col gap-4 w-full mt-6">
                    {posts.map((post) => (
                      <Post
                        key={post._id}
                        post={post}
                        onPostLike={onPostLike}
                      />
                    ))}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default OthersProfileSection;
